namespace GeniuzPOS.AdvPromo {
    export class PsAdvPromoItem6Columns {
        static columnsKey = 'AdvPromo.PsAdvPromoItem6';
    }
}
